import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Check from '@atlaskit/icon/glyph/check';
import { token } from '@atlaskit/tokens';

import { Day } from '../Day';

export const ThirdDay = () => {
	const thirdDayTitle = (
		<FormattedMessage
			id="end-of-trial-payment-modals.standard.timeline.3-days-left.title"
			defaultMessage="Today: Trial ends in 3 days"
			description="Title for 3-days left timeline item"
		/>
	);

	const thirdDaySubtitle = (
		<FormattedMessage
			id="end-of-trial-payment-modals.standard.timeline.3-days-left.subtitle"
			defaultMessage="Determine whether Standard is right for your team."
			description="Subtitle for 3-days left timeline item"
		/>
	);

	return (
		<Day
			title={thirdDayTitle}
			subtitle={thirdDaySubtitle}
			icon={
				<Check
					label="trial ends in three days"
					primaryColor={token('color.text.brand')}
					size="small"
				/>
			}
		/>
	);
};
